const reducer = (state, action) => {
  // console.log('reducer: ', state, action);
  switch (action.type) {
    case 'setEvents':
      return { ...state, events: action.value };
    case 'setRange':
      return { ...state, range: action.value };
    case 'setFilters':
      const nextSelected = action.value;
      const newFilters = state.filters.map((x, index) => {
        if (nextSelected.indexOf(index) >= 0) {
          return {
            ...x,
            selected: true,
          };
        }
        return {
          ...x,
          selected: false,
        };
      });
      return { ...state, filters: newFilters };
    default:
      throw new Error();
  }
};

export default reducer;
